"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoError = void 0;
class CryptoError extends Error {
    message;
    constructor(message, cause) {
        super(message, { cause });
        this.message = message;
        this.name = 'CryptoError';
        Object.setPrototypeOf(this, CryptoError.prototype);
    }
}
exports.CryptoError = CryptoError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3J5cHRvLWVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NyeXB0by1lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLFdBQVksU0FBUSxLQUFLO0lBQ1I7SUFBNUIsWUFBNEIsT0FBZSxFQUFFLEtBQWU7UUFDMUQsS0FBSyxDQUFDLE9BQU8sRUFBRSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUE7UUFEQyxZQUFPLEdBQVAsT0FBTyxDQUFRO1FBR3pDLElBQUksQ0FBQyxJQUFJLEdBQUcsYUFBYSxDQUFBO1FBQ3pCLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLFdBQVcsQ0FBQyxTQUFTLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0NBQ0Y7QUFQRCxrQ0FPQyJ9